import Navbar from "@/components/Navbar";
import LegalPolicy from "@/components/LegalPolicy";
import Footer from "@/components/Footer";

export default function RefundPolicyPage() {
  return (
    <div className="bg-[#050505] text-white min-h-screen" data-testid="refund-policy-page">
      <Navbar />
      <main className="pt-16">
        <div className="max-w-5xl mx-auto px-6 lg:px-8 pt-10">
          <a
            href="/"
            className="inline-flex items-center gap-2 text-xs tracking-[0.25em] uppercase text-white/40 hover:text-[#EAB308] transition-colors"
            data-testid="refund-back-link"
          >
            ← Volver al inicio
          </a>
        </div>
        <LegalPolicy />
      </main>
      <Footer />
    </div>
  );
}
